import { ActionTree } from "vuex";
import { StateInterface } from "src/store";
import { EventsUtilsStateInterface } from "./state";
import EventBus from "src/services/event-bus";
import { EventItem } from "../../models";
import MaRefs from "src/modules/ma/classes/ma_refs";
import { getSwearWords } from "src/modules/utils/recorder/getter-swear-words";
import { getRegExpSwearWords } from "src/modules/utils/recorder/get-regexp-swear-words";

const actions: ActionTree<EventsUtilsStateInterface, StateInterface> = {
  /**
   * Воспроизведение событий
   */
  async playEventsNow(
    context,
    payload: { events: EventItem[] }
  ): Promise<void> {
    // console.log("playEventsNow", payload);
    const event_types = MaRefs.str.ds_event_types;
    const events_for_play = payload.events.filter((event: EventItem) =>
      MaRefs.compareAsStr(event.type_ref, event_types.bot_message)
    );
    if (events_for_play.length) {
      EventBus.$emit("stopChatAudioPlayer");
      events_for_play.forEach((event: EventItem) => {
        EventBus.$emit("messageAdded", event);
      });
    }
    return Promise.resolve();
  },

  initSwearWords(context) {
    const hasSettingSwearHandlerMode = context.rootState.settings.list.addSwearHandlerMode?.value;
    if (!hasSettingSwearHandlerMode) return;
    const settingSwearWordsMode = context.rootState.settings.list.getSwearWordsMap?.value || '';
    const swearWordsArray = getSwearWords(settingSwearWordsMode);
    const regExpSwearWords = getRegExpSwearWords(swearWordsArray);
    context.commit('setSwearWords', { swearWordsArray, regExpSwearWords });
  },
};

export default actions;
